import ModalsModule from './modals.module'

export default ModalsModule
